import type { LoyaltyFeatureConfig } from './type';

export const loyalty: LoyaltyFeatureConfig = {
    icon: 'stars',
    targetClientId: '',
};
